import React from "react";
export default function NavigationContainer() {
    const currentSite = window.location.pathname;
    return (React.createElement("div", { className: "navigation-container" },
        React.createElement("a", { className: currentSite == "/price-list.html" ? "current-site" : "", href: "./price-list.html" }, "Cennik"),
        React.createElement("a", { href: "https://dokumentacja.fhub.pl" }, "Dokumentacja"),
        React.createElement("a", { className: currentSite == "/contact.html" ? "current-site" : "", href: "./contact.html" }, "Kontakt")));
}
